export default {"src":"/_next/static/media/x-icon.49c2cfbb.svg","height":42,"width":50,"blurWidth":0,"blurHeight":0};